import { useDocumentTitle } from "../chrome/useDocumentTitle";
import { ButtonLink } from "../components/Button";
import { EmptyState } from "../components/EmptyState";
import { paths } from "../routing/paths";

export const NotFound = () => {
  useDocumentTitle("Not found");
  return (
    <EmptyState
      action={
        <ButtonLink size="sm" to={paths.dashboard()} variant="accent">
          Back to repositories
        </ButtonLink>
      }
      body="That page isn't in the shop. Head back to your repositories."
      style={{ paddingTop: 96 }}
      title="Not on the bench."
    />
  );
};
